/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $InsiderStatsMatchSchema = {
    properties: {
        match: {
            type: 'MatchSmall',
            isRequired: true,
        },
        views: {
            type: 'number',
            isRequired: true,
        },
    },
} as const;
